<template>
    <div>
        <div class="yq-page-head">
            <div class="yq-page-name">{{template?template.name:(page?page.name:'')}}</div>
            <div class="yq-page-toolbar">
                <time-interval-picker v-model="timeInterval"></time-interval-picker>
                <el-link @click="refresh" :underline="false" icon="el-icon-refresh">刷新</el-link>
            </div>
        </div>
        <grid-layout v-if="pageConfig"
                     :layout.sync="pageConfig.sections"
                     :col-num="24"
                     :row-height="30"
                     :is-draggable="false"
                     :is-resizable="false"
                     :is-mirrored="false"
                     :vertical-compact="true"
                     :margin="[10, 10]"
                     :use-css-transforms="true"
        >
            <grid-item v-for="item in pageConfig.sections"
                       :x="item.x"
                       :y="item.y"
                       :w="item.w"
                       :h="item.h"
                       :i="item.i"
                       :key="item.i">
                <component :is="item.component" :id="item.id" :name="item.name" :show-config-ui="false"
                           :page-id="isTemplate?null:idValue" :template-id="isTemplate?idValue:null"
                           :refresh-id="item.refreshId" :time-interval="timeInterval"></component>
            </grid-item>
        </grid-layout>
    </div>
</template>

<script>
    import pageTemplateService from '../../service/page-template'
    import pageService from '../../service/page'
    import sectionTypeService from '../../service/section-type'
    import VueGridLayout from 'vue-grid-layout'
    import TimeIntervalPicker from '../common/DateIntervalPicker'

    export default {
        name: "SectionsPage",
        props: ["id", "isTemplate"],
        components: {
            GridLayout: VueGridLayout.GridLayout,
            GridItem: VueGridLayout.GridItem,
            TimeIntervalPicker
        },
        data() {
            return {
                template: null,
                page: null,
                pageConfig: null,
                timeInterval: null
            }
        },
        computed:{
            idValue(){
                return this.id?parseInt(this.id):null
            }
        },
        watch:{
            id(){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods: {
            async init(){
                try {
                    if (this.isTemplate) {
                        const response = await pageTemplateService.getPageTemplate(this.id)
                        this.template = response.data
                        if (this.template.pageConfig) {
                            this.pageConfig = this.parsePageConfig(this.template.pageConfig)
                        } else {
                            this.pageConfig = {
                                sections: []
                            }
                        }
                    } else {
                        const response = await pageService.getPage(this.id)
                        this.page = response.data
                        if (this.page.config) {
                            this.pageConfig = this.parsePageConfig(this.page.config)
                        } else {
                            this.pageConfig = {
                                sections: []
                            }
                        }
                    }
                    this.timeInterval = this.pageConfig.timeInterval
                } catch (e) {
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                }
            },
            parsePageConfig(json){
                const pageConfig = JSON.parse(json)
                for (const section of pageConfig.sections) {
                    const sectionType = sectionTypeService.getSectionType(section.type)
                    section.component = section.id ? sectionType.component : sectionType.preview
                    section.refreshId = 0
                }
                if(!pageConfig.datasources){
                    pageConfig.datasources=[]
                }
                if(!pageConfig.sections){
                    pageConfig.sections=[]
                }
                if(!pageConfig.timeInterval){
                    pageConfig.timeInterval = 'P1M'
                }
                return pageConfig
            },
            refresh(){
                for(const section of this.pageConfig.sections){
                    section.refreshId++
                }
            }
        }
    }
</script>
<style scoped>

</style>
